"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var useTabDragScroller = function (scrollableElement) {
    var scrolledPosition = React.useRef({ scrollLeft: 0, x: 0 });
    var touchStartHandler = function (e) {
        var position = {
            scrollLeft: scrollableElement.scrollLeft,
            x: e.touches[0].clientX
        };
        scrolledPosition.current = position;
    };
    var touchMoveHandler = function (e) {
        var _a = scrolledPosition.current, scrollLeft = _a.scrollLeft, x = _a.x;
        var howMuchMoved = e.touches[0].clientX - x;
        scrollableElement.scrollLeft = scrollLeft - howMuchMoved;
    };
    return { touchStartHandler: touchStartHandler, touchMoveHandler: touchMoveHandler };
};
exports.default = useTabDragScroller;
